import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19283 17130"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:279.465}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278497424">
        <path
          d="M1407 16990c700 0 1268-568 1268-1268s-567-1267-1268-1267c-700 0-1267 567-1267 1267s567 1268 1267 1268zM1407 12218c700 0 1268-568 1268-1267 0-700-567-1269-1268-1269-700 0-1267 568-1267 1269 0 700 567 1267 1267 1267zM5524 16990c700 0 1268-568 1268-1268s-567-1267-1268-1267c-700 0-1267 567-1267 1267s567 1268 1267 1268zM5524 12218c700 0 1268-568 1268-1267 0-700-567-1269-1268-1269-700 0-1267 568-1267 1269 0 700 567 1267 1267 1267zM5524 7447c700 0 1268-568 1268-1268s-567-1267-1268-1267c-700 0-1267 567-1267 1267s567 1268 1267 1268zM9641 16990c700 0 1268-568 1268-1268s-568-1267-1268-1267-1268 567-1268 1267c1 700 568 1268 1268 1268zM9641 12218c700 0 1268-568 1268-1267 0-700-568-1269-1268-1269s-1268 568-1268 1269c0 700 568 1267 1268 1267zM9641 7447c700 0 1268-568 1268-1268s-568-1267-1268-1267-1268 567-1268 1267c1 700 568 1268 1268 1268zM9641 2675c700 0 1268-567 1268-1267 0-701-568-1268-1268-1268S8373 707 8373 1408c1 699 568 1267 1268 1267zM13759 16990c699 0 1268-568 1268-1268s-568-1267-1268-1267-1268 567-1268 1267c-1 700 567 1268 1268 1268zM13759 12218c699 0 1268-568 1268-1267 0-700-568-1269-1268-1269s-1268 568-1268 1269c0 700 567 1267 1268 1267zM13759 7447c699 0 1268-568 1268-1268s-568-1267-1268-1267-1268 567-1268 1267c-1 700 567 1268 1268 1268zM17875 16990c700 0 1268-568 1268-1268s-567-1267-1268-1267c-700 0-1267 567-1267 1267s567 1268 1267 1268zM17875 12218c700 0 1268-568 1268-1267 0-700-567-1269-1268-1269-700 0-1267 568-1267 1269 0 700 567 1267 1267 1267z"
          className="fill stroke1"
          style={{
            strokeWidth: 279.465,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
